import type { State } from '../../types.tsx';

export const isDragging = (state: State): boolean => state.ui.drag.isDragging;
export const getSourceDroppableType = (state: State) => state.ui.drag.sourceCardGroupType;
export const getSourceCardListId = (state: State) => state.ui.drag.sourceCardListId;
export const getIsSubtaskDrag = (state: State): boolean => state.ui.drag.isSubtask;
export const getSourceParentId = (state: State) => state.ui.drag.sourceParentId;
export const getIsOverTransitionZone = (state: State) => state.ui.drag.isOverTransitionZone;
